import TEXTS from "../../../locale/texts";
import { makeMsisdnBeautiful } from '../../../Utils';

export const contactsFromContactsColumns = (lang = 'ru') =>
    [
      {
        title: TEXTS.contactPhoneLabel[lang],
        dataIndex: 'msisdn',
        render: (text) => typeof text === 'string'
          ? makeMsisdnBeautiful(text) : '—'
      },
      {
        title: TEXTS.thPhoneGroups[lang],
        dataIndex: 'groups',
        render: (text) => (typeof text === 'number' || typeof text === 'string') ? text : '—'
      },
      {
        title: TEXTS.thFIO[lang],
        dataIndex: 'firstname',
        render: (text) => (typeof text === 'number' || typeof text === 'string') ? text : '—'
      },
      {
        title: TEXTS.contactCityLabel[lang],
        dataIndex: 'city',
        render: (text) => (typeof text === 'number' || typeof text === 'string') ? text : '—'
      },
      {
        title: TEXTS.thGender[lang],
        dataIndex: 'gender',
        render: (text) => (typeof text === 'number' || typeof text === 'string') ? text : '—'
      },
      {
        title: TEXTS.birthDate[lang],
        dataIndex: 'birthDate',
        render: (text) => (typeof text === 'number' || typeof text === 'string') ? text : '—'
      }
    ];
